import { Icons } from "@workspace/ui/components/icons";

import { MarketingLayout } from "~/components/common/layout/marketing";
import { Section } from "~/components/common/layout/section";
import { TurboLink } from "~/components/common/turbo-link";
import { ProjectsMarquee } from "~/components/marketing/home/core/showcase/showcase";
import { appConfig } from "~/config/app";

interface IdeasLayoutProps {
  readonly children: React.ReactNode;
  readonly after?: React.ReactNode;
  readonly title: string;
  readonly description: string;
  readonly badge?: {
    text: string;
    href: string;
  };
}

export const IdeasLayout = ({
  children,
  after,
  title,
  description,
  badge,
}: IdeasLayoutProps) => (
  <MarketingLayout
    title={title}
    description={description}
    {...(badge && {
      badge: (
        <TurboLink
          href={badge.href}
          className="border-border/50 bg-card shadow-primary/15 hover:bg-muted/50 dark:border-border dark:hover:bg-muted/65 group mb-6 flex items-center gap-2 rounded-full border px-2 py-1.5 pr-4 text-xs shadow-[0px_12px_32px_0px] transition-colors sm:text-sm"
        >
          <div className="bg-muted flex gap-1 rounded-full p-1.5">
            <Icons.Champion className="w-3.5 md:w-4" />
          </div>
          <span className="font-medium">{badge.text}</span>
          <Icons.ArrowRight className="w-4 transition-transform group-hover:translate-x-1" />
        </TurboLink>
      ),
    })}
    after={
      <>
        {after}

        <Section
          id="showcase"
          className="!col-span-full grid grid-cols-subgrid !pb-0"
        >
          <div className="col-start-2 flex flex-col items-center justify-center gap-4 md:gap-6">
            <h2 className="max-w-2xl text-center text-3xl font-medium tracking-tight text-balance sm:text-4xl md:text-5xl">
              Your competitors are building with {appConfig.name}
            </h2>

            <p className="text-muted-foreground max-w-3xl text-center text-sm text-pretty md:text-base">
              Below are some of the SaaS ideas that have been generated and
              built with our starter kit.
            </p>
          </div>

          <ProjectsMarquee />
        </Section>
      </>
    }
  >
    {children}
  </MarketingLayout>
);
